import type { Brand, BrandConfig } from '@comparit/infrastructure';
import { mlpBrandConfig } from './mlp/mlp-brand.config';

export const kfzBrandRegistry: Partial<Record<Brand, BrandConfig>> = {
  mlp: mlpBrandConfig,
};
